import { Activity } from "lucide-react";
import GlassCard from "./GlassCard";
import Dropdown from "./Dropdown";
import DonutChart from "./DonutChart";
const IssueDonutCard = ({ title, count, caption, chartData, chartTitle, personalGrowth = false, dropdown, accent = "violet" }) => {
  return (
    <GlassCard accent={accent} className="flex flex-col text-slate-900 dark:text-white">
      <div className="w-full flex flex-row items-start justify-between gap-3">
        <h1 className="font-['Space_Grotesk',_sans-serif] text-[19px] leading-tight font-semibold">{title}</h1>
        {dropdown && (
          <div className="shrink-0 rounded-xl bg-black/[0.03] dark:bg-white/[0.04] border border-black/[0.06] dark:border-white/[0.06]">
            <Dropdown value={dropdown.value} onChange={dropdown.onChange} options={dropdown.options} label="Select option" />
          </div>
        )}
      </div>

      <div className="flex flex-row gap-2 items-center mt-3">
        <Activity size={16} className="text-[#F0498C]" />
        <h3 className="font-['IBM_Plex_Mono',_monospace] text-[#F0498C] text-[17px] font-semibold tabular-nums">
          {count || 0}
        </h3>
      </div>
      {/* <p className="text-slate-400 dark:text-white/40 text-[12px] mt-0.5">{caption}</p> */}

      <div className="w-full mt-2">
        <DonutChart data={chartData} title={chartTitle} personalGrowth={personalGrowth} />
      </div>
    </GlassCard>
  );
};
var IssueDonutCard_default = IssueDonutCard;
export { IssueDonutCard_default as default };